<form
  #tForm
  [action]="endpoint()"
  method="get" style="display: none">
  <input [value]="clientId()" name="client_id">
  <input [value]="redirectUri()" name="redirect_uri">
  <input [value]="scope()" name="scope">
  <input name="response_type" value="code">
  <input [value]="state()" name="state">
  <button type="submit">send</button>
</form>
<div (click)="tForm.submit()"
     (keyup)="tForm.submit()"
     class="button"
     tabindex="0">
  <img
    alt="login with gitlab icon" src="gitlab.png" width="40">
  Identify with GitLab
</div>
